<show-modal-terminosy-condiciones></show-modal-terminosy-condiciones>

<div>

  <app-loader-subito></app-loader-subito>

  <shared-slider-info></shared-slider-info>

  <!-- Type Establishment Bar with defer loading -->
  @defer (on immediate) {
    <div class="mx-10">
      <shared-categories-establishment></shared-categories-establishment>
    </div>
  } @loading {
  <div class="bg-gray-100 animate-pulse rounded-lg h-24 mx-4 my-2"></div>
  } @error {
  <shared-error-message
    message="No se pudo cargar los tipos de establecimientos"
  ></shared-error-message>
  } @placeholder {
  <div class="bg-gray-100 animate-pulse rounded-lg h-24 mx-4 my-2"></div>
  }

  <!-- Explora Nuestro Menu with defer loading -->
  @defer (on immediate) {
      <shared-explora-nuestro-menu></shared-explora-nuestro-menu>
  } @loading {
  <div class="bg-gray-100 animate-pulse rounded-lg h-32 mx-4 my-2"></div>
  } @error {
  <shared-error-message
    message="No se pudo cargar el menú de restaurantes"
  ></shared-error-message>
  } @placeholder {
  <div class="bg-gray-100 animate-pulse rounded-lg h-32 mx-4 my-2"></div>
  }

  <!-- Unetenos with defer loading -->
  @defer (on viewport) {
  <shared-unetenos></shared-unetenos>
  } @loading {
  <div class="bg-gray-100 animate-pulse rounded-lg h-40 mx-4 my-2"></div>
  } @error {
  <shared-error-message
    message="No se pudo cargar la sección únete"
  ></shared-error-message>
  } @placeholder {
  <div class="bg-gray-100 animate-pulse rounded-lg h-40 mx-4 my-2"></div>
  }

  <!-- Download Apps with defer loading -->
  @defer (on viewport) {
  <features-download-apps></features-download-apps>
  } @loading {
  <div class="bg-gray-100 animate-pulse rounded-lg h-32 mx-4 my-2"></div>
  } @error {
  <shared-error-message
    message="No se pudo cargar la sección de descarga de apps"
  ></shared-error-message>
  } @placeholder {
  <div class="bg-gray-100 animate-pulse rounded-lg h-32 mx-4 my-2"></div>
  }
</div>


